import { useContent } from "@/context/ContentContext";

const DEFAULT_STAPPEN = [
  {
    title: "1. Jouw Idee & Wensen",
    text: "Stuur via het aanvraagformulier je wensen, afmetingen of foto's door. We bespreken het doel en de sfeer.",
  },
  {
    title: "2. Meedenken & Ontwerp",
    text: "René adviseert over houtsoorten, constructie en afwerking. Je ontvangt een duidelijk voorstel.",
  },
  {
    title: "3. Ambacht in Werkplaats",
    text: "Het hout wordt geselecteerd, gezaagd, geschaafd, met zorg verbonden en duurzaam afgewerkt in Rijswijk.",
  },
  {
    title: "4. Levering & Genieten",
    text: "Je meubel is klaar voor gebruik. Een tijdloos stuk waar je nog vele jaren plezier van hebt.",
  },
];

export const Process = () => {
  const { content } = useContent();
  const stappen = content?.process?.length
    ? DEFAULT_STAPPEN.map((s, i) => ({ ...s, ...(content.process[i] || {}) }))
    : DEFAULT_STAPPEN;

  return (
    <section id="werkwijze" data-testid="process-section" className="py-24 px-6 max-w-7xl mx-auto">
      <div className="text-center max-w-2xl mx-auto mb-16 hr-reveal">
        <span className="text-xs uppercase tracking-widest text-[#9C6D3B] font-bold">Stap voor stap</span>
        <h2 className="text-3xl sm:text-4xl font-normal font-display text-[#2B231D] mt-2">
          Hoe ontstaat jouw maatwerk meubel?
        </h2>
        <p className="text-sm text-[#6C5E52] mt-3">Transparant en persoonlijk vanaf het eerste gesprek.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
        {stappen.map((s, i) => (
          <div
            key={i}
            data-testid={`process-step-${i + 1}`}
            className="relative p-6 rounded-2xl bg-[#FBF9F5] border border-[#EAE3DA] hr-reveal"
          >
            <div className="w-8 h-8 rounded-full bg-[#2B231D] text-[#E6AF68] flex items-center justify-center text-xs font-bold mb-4">
              ◆
            </div>
            <h3 className="text-base font-bold text-[#2B231D] mb-2">{s.title}</h3>
            <p className="text-xs text-[#6C5E52] leading-relaxed">{s.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
};
